import React, {Component} from 'react';
import Titulo from '../comum/Titulo';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import {formatCPF, formatTelefone, formatPontos} from '../../util/numberUtil'
import Autorizacao from '../../security/Autorizacao';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import buscarClientesPorEmpresa from '../../actions/adesao-pontos/buscarClientesEmpresa';
import {reduxForm} from 'redux-form';
import iconeCash from '../../img/cash-coin.svg';
import iconAudoria from '../../img/auditoria.png';
import iconHistoricoTransferencia from '../../img/transferencia-de-passageiros.png';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="table-responsive">
            <table className="table table-striped table-bordered" style={{textAlign: 'center'}}>
                <thead>
                <tr>
                    <th className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Id</th>
                    <th className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Nome</th>
                    <th className="col-6 col-sm-1 col-md-1 col-lg-1 col-xl-1">CPF</th>
                    <th className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Email</th>
                    <th className="col-6 col-sm-1 col-md-1 col-lg-1 col-xl-1">Telefone</th>
                    <th className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Pontos Disponíveis</th>
                    <th className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Pontos Congelados</th>
                    <th className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Ações</th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
);

export class PainelGerenciarClientesEmpresa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listaClientes: []
        };
    }

    componentDidMount() {
        this.props.buscarClientesPorEmpresa(this.props.empresaSelecionada.id);
    }

    exibirListaClientes() {
        if (this.props.listaClientes && this.props.listaClientes.length) {
            return (
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <tbody>
                        {this.props.listaClientes.map(cliente => (
                            <tr key={`lista-clientes-${cliente.id}`} style={{textAlign: 'center'}}>
                                <td className="col-6 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{alignContent: 'center'}}>{cliente.id}</td>
                                <td className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{alignContent: 'center'}}>{cliente.nome}</td>
                                <td className="col-6 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{alignContent: 'center'}}>{formatCPF(cliente.cpf)}</td>
                                <td className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{alignContent: 'center'}}>{cliente.email || 'N/A'}</td>
                                <td className="col-6 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{alignContent: 'center'}}>{formatTelefone(cliente.telefone)}</td>
                                <td className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{alignContent: 'center', color: 'green'}}><b>{formatPontos(cliente.pontosDisponiveis)}</b></td>
                                <td className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{alignContent: 'center', color: 'red'}}><b>{formatPontos(cliente.pontosCongelados)}</b></td>
                                <td className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{alignContent: 'center'}}>
                                    <div id='container-botoes' className="col-sm-2 mr-md-n4">
                                        <div className='dropdown'>
                                            <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown"
                                                    type="button"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="material-icons">
                                                    &#xe5d4;
                                                </i>
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <div className="botoes">
                                                    <button type="button" className="btn btn-editar "
                                                            data-toggle="modal"
                                                            title='Editar'
                                                            data-target='#modalCadastrarItinerario'>
                                                        <i className="material-icons nav-icon">&#xe150;</i>
                                                    </button>
                                                    <button type="button" className="btn btn-excluir "
                                                            title='Lista de viagens'>
                                                        <i className="material-icons nav-icon">&#xe637;</i>
                                                    </button>
                                                    <Link
                                                        to={'/#'}
                                                        target="_blank"
                                                        title='Recibos de Cupons'
                                                        className="btn btn-editar">
                                                        <i className="material-icons nav-icon">&#xe638;</i>
                                                    </Link>
                                                    <button type="button" className="btn btn-excluir "
                                                            title='Trocar pontos'>
                                                        <i className="material-icons nav-icon">&#xe8d5;</i>
                                                    </button>
                                                    <button type="button" className="btn btn-excluir "
                                                            title='Detalhamento Financeiro'>
                                                        <i className="material-icons nav-icon">&#xe263;</i>
                                                    </button>
                                                    <button type="button" className="btn ml-2"
                                                            data-toggle="modal"
                                                            title='Relação de valores da rota'
                                                            data-target="#modalPrecosRota">
                                                        <img style={{cursor: 'pointer'}} title='Preços'
                                                             src={iconeCash}/>
                                                    </button>
                                                    <button type="button" className="btn ml-2"
                                                            data-toggle="modal"
                                                            title='Buscar últimos Históricos'
                                                            data-target="#modal">
                                                        <img src={iconAudoria} width={18} height={18}
                                                             alt="Históricos Itinerário"/>
                                                    </button>
                                                    <button type="button" className="btn ml-2"
                                                            data-toggle="modal"
                                                            title='Buscar Históricos Transferências'
                                                            data-target="#modal">
                                                        <img src={iconHistoricoTransferencia} width={18} height={18}
                                                             alt="Históricos Transferências"/>
                                                    </button>
                                                    <button id='buttonExcluir' type="button" className="btn ml-2"
                                                            title='Excluir'
                                                            data-toggle="modal"
                                                            data-target="#modal">
                                                        <svg id='excluirItinerario'
                                                             xmlns="http://www.w3.org/2000/svg" width="18"
                                                             height="18" fill="currentColor" className="bi bi-trash"
                                                             viewBox="0 0 16 16">
                                                            <path
                                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                            <path
                                                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            );
        }
        return '';
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}
                         empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas col-md-12">
                        <Titulo texto="Gerenciar Clientes Pontuação" urlRetorno="/menu-adesao-pontos-empresa"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <CabecalhoTabela/>
                            {this.exibirListaClientes()}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        listaClientes: state.buscarClientesEmpresa || [],
        authentication: state.authentication,
        empresaSelecionada: state.empresaSelecionada,
    }
}

export default withRouter(connect(mapStateToProps, {
    buscarClientesPorEmpresa
})(reduxForm({
    form: 'formularioPainelGerenciarClientesEmpresa'
})(PainelGerenciarClientesEmpresa)));